import { nsOrganization } from '@/app/i18n/namespaces';
import ORGANIZATION_TYPE from '../enums/OrganizationTypes';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

const validateSiret = value => {
    if (value && value.length === 14) {
        // Check Luhn's key
        return value
            .split('')
            .reduce(
                (acc, digit, index) => {
                    const tmp = digit * (2 - (index % 2));
                    return acc + (tmp > 9 ? tmp - 9 : tmp);
                },
                0
            ) % 10 === 0 ?
            undefined
            : 'INVALID_REGISTRATION_NUMBER';
    }

    return 'INVALID_REGISTRATION_NUMBER';
};

export default {
    UUID: {
        key: 'uuid'
    },
    PROVIDER_UUID: {
        key: 'provider'
    },
    TYPE: {
        key: 'type',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.type',
        prefix: 'type.',
        validate: value => value ? undefined : 'INVALID_ORGANIZATION_TYPE',
        isRequired: true,
        enableSorting: true,
        namespace: nsOrganization,
        enum: ORGANIZATION_TYPE,
        filter: FILTER_TYPES.SELECT
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: 'tel',
        entity: 'keys.registration_number',
        validate: validateSiret,
        maxLength: 14,
        isRequired: true,
        namespace: nsOrganization,
        enableSorting: true,
        placeholder: 'filter.placeholder.registration_number',
        filter: FILTER_TYPES.INPUT
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.legal_name',
        validate: value => value ? undefined : 'INVALID_LEGAL_NAME',
        isRequired: true,
        namespace: nsOrganization,
        enableSorting: true,
        placeholder: 'filter.placeholder.legal_name',
        filter: FILTER_TYPES.INPUT
    },
    BUSINESS_NAME: {
        key: 'businessName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.business_name',
        namespace: nsOrganization,
        enableSorting: true,
        placeholder: 'filter.placeholder.business_name',
        filter: FILTER_TYPES.INPUT
    },
    // LEGAL INFO
    LEGAL_INFOS: {
        key: 'legalInfos',
        REGISTRATION_NUMBER: {
            parentKeys: ['legalInfos'],
            key: 'registrationNumber',
            type: 'tel',
            entity: 'keys.registration_number',
            namespace: nsOrganization,
            //validate: validateSiret,
            maxLength: 14
        },
        HEAD_OFFICE_REGISTRATION_NUMBER: {
            parentKeys: ['legalInfos'],
            key: 'headOfficeRegistrationNumber',
            type: 'tel',
            entity: 'keys.head_office_registration_number',
            namespace: nsOrganization,
            //validate: value => /^\d{9}$/.test(value) ? undefined : 'INVALID_HEAD_OFFICE_REGISTRATION_NUMBER',
            maxLength: 9
        },
        BRANCH_NUMBER: {
            parentKeys: ['legalInfos'],
            key: 'branchNumber',
            type: 'tel',
            entity: 'organization_branch_number',
            //validate: value => /^\d{5}$/.test(value) ? undefined : 'INVALID_BRANCH_NUMBER',
            maxLength: 5
        },
        NORMALIZED_ADDRESS_L1: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL1',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l1'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L2: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL2',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l2'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L3: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL3',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l3'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L4: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL4',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l4'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L5: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL5',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l5'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L6: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL6',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l6'
            //validate: () => undefined
        },
        NORMALIZED_ADDRESS_L7: {
            parentKeys: ['legalInfos'],
            key: 'normalizedAddressL7',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_normalized_address_l7'
            //validate: () => undefined
        },
        POSTAL_CODE: {
            parentKeys: ['legalInfos'],
            key: 'postalCode',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_postal_code'
            //validate: value => value && value.length >= 3 ? undefined : 'INVALID_POSTAL_CODE'
        },
        BUSINESS_POSTAL_CODE: {
            parentKeys: ['legalInfos'],
            key: 'businessPostalCode',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_business_postal_code'
            //validate: () => undefined
        },
        CITY_NAME: {
            parentKeys: ['legalInfos'],
            key: 'cityName',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_city_name'
            //validate: value => value ? undefined : 'INVALID_CITY_NAME'
        },
        IS_HEAD_OFFICE: {
            parentKeys: ['legalInfos'],
            key: 'isHeadOffice',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_is_head_office'
            //validate: () => undefined
        },
        BUSINESS_NAME: {
            parentKeys: ['legalInfos'],
            key: 'businessName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.business_name',
            namespace: nsOrganization
            //validate: () => undefined
        },
        BRANCH_BUSINESS_SECTOR_CODE: {
            parentKeys: ['legalInfos'],
            key: 'branchBusinessSectorCode',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_branch_business_sector_code',
            //validate: value => /^\d{4}[A-Z]$/.test(value) ? undefined : 'INVALID_BRANCH_BUSINESS_SECTOR_CODE',
            maxLength: 5
        },
        BRANCH_BUSINESS_SECTOR_LABEL: {
            parentKeys: ['legalInfos'],
            key: 'branchBusinessSectorLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.branch_business_sector_label',
            namespace: nsOrganization
            //validate: value => value ? undefined : 'INVALID_BRANCH_BUSINESS_SECTOR_LABEL'
        },
        COMPANY_LONG_NAME: {
            parentKeys: ['legalInfos'],
            key: 'companyLongName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.company_long_name',
            namespace: nsOrganization
            //validate: value => value ? undefined : 'INVALID_COMPANY_LONG_NAME'
        },
        ACRONYM: {
            parentKeys: ['legalInfos'],
            key: 'acronym',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_acronym'
            //validate: () => undefined
        },
        CIVILITY: {
            parentKeys: ['legalInfos'],
            key: 'civility',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_civility'
            //validate: () => undefined
        },
        FORNAME: {
            parentKeys: ['legalInfos'],
            key: 'forname',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_forname'
            //validate: () => undefined
        },
        LASTNAME: {
            parentKeys: ['legalInfos'],
            key: 'lastname',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_lastname'
            //validate: () => undefined
        },
        EMAIL: {
            parentKeys: ['legalInfos'],
            key: 'email',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_email'
            //validate: () => undefined
        },
        PHONE: {
            parentKeys: ['legalInfos'],
            key: 'phone',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_phone'
            //validate: () => undefined
        },
        HEAD_OFFICE_BRANCH_NUMBER: {
            parentKeys: ['legalInfos'],
            key: 'headOfficeBranchNumber',
            type: 'tel',
            entity: 'organization_head_office_branch_number',
            // validate: value => /^\d{5}$/.test(value) ? undefined : 'INVALID_BRANCH_NUMBER',
            maxLength: 5
        },
        LEGAL_NATURE_CODE: {
            parentKeys: ['legalInfos'],
            key: 'legalNatureCode',
            type: 'tel',
            entity: 'organization_legal_nature_code'
            // validate: value => /^\d{4}$/.test(value) ? undefined : 'INVALID_LEGAL_NATURE_CODE'
        },
        LEGAL_NATURE_LABEL: {
            parentKeys: ['legalInfos'],
            key: 'legalNatureLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.legal_nature_label',
            namespace: nsOrganization
            // validate: value => value ? undefined : 'INVALID_LEGAL_NATURE_LABEL'
        },
        COMPANY_BUSINESS_SECTOR_CODE: {
            parentKeys: ['legalInfos'],
            key: 'companyBusinessSectorCode',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_company_business_sector_code',
            // validate: value => /^\d{4}[A-Z]$/.test(value) ? undefined : 'INVALID_COMPANY_BUSINESS_SECTOR_CODE',
            maxLength: 5
        },
        COMPANY_BUSINESS_SECTOR_LABEL: {
            parentKeys: ['legalInfos'],
            key: 'companyBusinessSectorLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_company_business_sector_label'
            // validate: value => value ? undefined : 'INVALID_COMPANY_BUSINESS_SECTOR_LABEL'
        },
        CREATION_DATE: {
            parentKeys: ['legalInfos'],
            key: 'creationDate',
            type: FIELD_TYPES.DATE,
            entity: 'keys.creation_date',
            namespace: nsOrganization
            // validate: () => undefined
        },
        UPDATE_DATE: {
            parentKeys: ['legalInfos'],
            key: 'updateDate',
            type: FIELD_TYPES.DATE,
            entity: 'keys.update_date',
            namespace: nsOrganization
            // validate: () => undefined
        }
    },
    PROVIDER_BRAND: {
        key: 'providerBrand',
        DOMAIN_NAME: {
            parentKeys: ['providerBrand'],
            key: 'domainName',
            type: 'url'
        }
    },
    BRAND: {
        key: 'brand',
        UUID: {
            parentKeys: ['brand'],
            key: 'uuid',
            entity: 'uuidd'
        },
        DOMAIN_NAME: {
            parentKeys: ['brand'],
            key: 'domainName',
            type: FIELD_TYPES.LINK,
            entity: 'keys.brand_domain_name',
            namespace: nsOrganization,
            validate: () => undefined
        },
        STYLE: {
            parentKeys: ['brand'],
            key: 'style',
            MAIN_COLOR: {
                parentKeys: ['brand', 'style'],
                key: 'mainColor',
                type: FIELD_TYPES.COLOR,
                entity: 'keys.main_color',
                namespace: nsOrganization,
                validate: value => /^#[0-9A-Fa-f]{6}$/.test(value) ? undefined : 'INVALID_COLOR'
            },
            ASSETS: {
                parentKeys: ['brand,style'],
                key: 'assets',
                LOGO: {
                    parentKeys: ['brand', 'style', 'assets'],
                    key: 'logo',
                    type: 'file',
                    entity: 'organization_brand_logo'
                },
                LOGO_PATH: {
                    parentKeys: ['brand', 'style', 'assets'],
                    key: 'logoPath',
                    type: FIELD_TYPES.IMAGE,
                    entity: 'keys.brand_logo',
                    namespace: nsOrganization,
                    placeholder: require('../../../../../resource/images/logo1.png')
                },
                FAVICON: {
                    parentKeys: ['brand', 'style', 'assets'],
                    key: 'favicon',
                    type: 'file',
                    entity: 'organization_brand_favicon'
                }
            }
        },
        SUB_DOMAIN_NAME: {
            key: 'subdomainName',
            type: FIELD_TYPES.TEXT,
            entity: '',
            validate: value => value && /^(?=.*[a-z-\d])[a-z-\d]{1,50}$/.test(value) ?
                undefined : 'INVALID_SUB_DOMAIN_NAME'
        },
        SUB_DOMAIN: {
            key: 'subdomain',
            type: FIELD_TYPES.TEXT,
            entity: '',
            validate: value => value && /^(?=.*[a-z-\d])[a-z-\d]{1,50}$/.test(value) ?
                undefined : 'INVALID_SUB_DOMAIN'
        }
    },
    PORT: {
        key: 'port',
        VALUE: {
            key: 'value',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_add_port_value',
            validate: value => /^\d{5}$/.test(value) ? undefined : 'INVALID_PORT'
        },
        TYPE: {
            key: 'type',
            type: 'select',
            entity: 'organization_add_port_type'
        }
    },
    CONTACT_UUID: {
        key: 'contact.uuid'
    },
    CONTACT_FIRSTNAME: {
        key: 'contact.firstname',
        type: FIELD_TYPES.TEXT,
        entity: 'contact_firstname'
    },
    CONTACT_LASTNAME: {
        key: 'contact.lastname',
        type: FIELD_TYPES.TEXT,
        entity: 'contact_lastname'
    },
    CONTACT_PHONE: {
        key: 'contact.phone',
        type: 'tel',
        entity: 'contact_phone'
    },
    CONTACT_EMAIL: {
        key: 'contact.email',
        type: FIELD_TYPES.TEXT,
        entity: 'contact_email'
    },
    COMMENT: {
        key: 'comment',
        type: FIELD_TYPES.TEXTAREA,
        entity: 'keys.comment',
        namespace: nsOrganization,
        validate: () => undefined
    },
    CLIENT_CODE: {
        key: 'clientCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.client_code',
        namespace: nsOrganization,
        validate: () => undefined
    },
    CONNECTION_POINTS: {
        key: 'connectionPoints',
        type: FIELD_TYPES.ARRAY,
        PORT: {
            parentKeys: ['connectionPoints'],
            key: 'port',
            type: FIELD_TYPES.PORT,
            entity: 'keys.connection_point_port',
            namespace: nsOrganization,
            validate: value => {
                if (!value) {
                    return undefined;
                } else {
                    return /^\d{4,5}$/.test(value) && parseInt(value, 10) >= 1024 && parseInt(value, 10) <= 65535 ? undefined : 'INVALID_PORT';
                }
            }
        },
        IP_ADDRESS: {
            parentKeys: ['connectionPoints'],
            key: 'ipAddress',
            entity: 'keys.connection_point_ip_address',
            namespace: nsOrganization,
            validate: value => {
                if (!value) {
                    return undefined;
                }
                const splittedIpAddress = value.split('.').map(block => parseInt(block, 10));
                if (splittedIpAddress.length !== 4) {
                    return 'INVALID_IP_ADDRESS_FORMAT';
                }
                if (!splittedIpAddress.every(block => block >= 0 && block < 256)) {
                    return 'INVALID_IP_ADDRESS_FORMAT';
                }
                return splittedIpAddress.join('.') === value ? undefined : 'INVALID_IP_ADDRESS_FORMAT';
            }
        },
        PORT_TYPE: {
            parentKeys: ['connectionPoints'],
            key: 'portType',
            type: FIELD_TYPES.TEXT,
            entity: 'organization_connection_point_port_type'
        }
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        enableSorting: true,
        namespace: nsOrganization,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        enableSorting: true,
        entity: 'keys.updated_at',
        namespace: nsOrganization,
        filter: FILTER_TYPES.DATE
    },
    SHOULD_BLOCK_NEW_POS: {
        key: 'shouldBlockNewPOS',
        type: FIELD_TYPES.TEXT,
        entity: 'organization_should_block_new_pos_title'
    },
    PORTS: {
        key: 'ports',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.ports',
        namespace: nsOrganization,
        placeholder: 'filter.placeholder.ports',
        filter: FILTER_TYPES.INPUT,
        enableSorting: false
    },
    PUSH_PAYMENT_PARTNERS: {
        key: 'pushPaymentEmitterPartners',
        type: FIELD_TYPES.ARRAY,
        UUID: {
            parentKeys: ['pushPaymentEmitterPartners'],
            key: 'uuid'
        },
        LEGAL_NAME: {
            parentKeys: ['pushPaymentEmitterPartners'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.push_payments_legal_name',
            namespace: nsOrganization
        }
    },
    BILLABLE: {
        key: 'billable',
        type: FIELD_TYPES.BOOLEAN,
        entity: 'keys.billable',
        namespace: nsOrganization
    },
    BILLING_ID_READ: {
        key: 'billingId',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.billing_id_read',
        namespace: nsOrganization
    },
    ADDRESS: {
        key: 'address'
    },
    CONTACT: {
        key: 'contact'
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    }
};